<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelCategoria"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :label="$t('Nome')"
    :allowEmpty="true"
    :preselectFirst="true"
    :loading="isLoading"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    class="multiselect-primary"
    inputContainerClass="d-flex"
    :hide-selected="false"
  >
    <template slot="tag" slot-scope="{ option, remove }" class="d-flex">
      <span class="multiselect__tag">
        <span>{{ option.nome }}</span>
        <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
      </span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'isTagabble', 'isObject', 'alreadySelected'],

  data() {
    return {
      selected: null,
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (e == null) {
        this.$emit('selectChange', 'id_tipo_categoria', null);
        return;
      }
      this.isObject == true
        ? this.$emit('selectChange', 'id_tipo_categoria', e)
        : this.$emit('selectChange', 'id_tipo_categoria', e.id);
    },
    labelCategoria({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      let selectedActual = this.options.find((option) => option.id === value);
      if (value) {
        this.selected = selectedActual;
      } else {
        this.selected = this.options.find((option) => option.id === null);
        selectedActual = this.options.find((option) => option.id === null);
      }
      if (this.alreadySelected) {
        this.selected = this.options.find((option) => option.id === this.alreadySelected);
      }
      this.onChange(selectedActual);
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('tipo_categoria', {
          columns: 'id, nome',
          order: 'id'
        })
        .then((res) => {
          this.options = [];
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: `${err.code} - ${err.message}`,
            msgTranslate: false,
            type: 'error'
          });
        });
    }
  },

  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  },

  created() {
    this.setOptions();
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
